<template>
    <div class="d-flex align-center">
        <div class="d-flex mr-12 mr-lg-22">
            <v-btn icon large outlined class="mr-4 mr-lg-8" @click="goPrevious" color="grey"><i class="icon icon-left-arrow-light"></i></v-btn>
            <v-btn icon large outlined @click="goNext" color="grey"><i class="icon icon-right-arrow-light"></i></v-btn>
        </div>
        <h3 class="font-size-20 font-size-lg-40 font-weight-bold">{{ month }}월 {{ year }}</h3>
    </div>
    <!-- <v-row justify="center" align="center">
        <v-col cols="auto">
            <v-btn x-small text fab color="grey" @click="goPrevious"> <v-icon>mdi-chevron-left</v-icon> </v-btn>
        </v-col>
        <v-col cols="auto"> {{ year }}년 {{ month }}월 </v-col>
        <v-col cols="auto">
            <v-btn x-small text fab color="grey" @click="goNext"> <v-icon>mdi-chevron-right</v-icon> </v-btn>
        </v-col>
    </v-row> -->
</template>

<script>
import dayjs from "dayjs";
export default {
    props: {
        value: { type: String, default: Date.now().toDate() }, //date
    },
    computed: {
        year() {
            return dayjs(this.value).year();
        },
        month() {
            return dayjs(this.value).month() + 1;
        },
    },
    methods: {
        goPrevious() {
            this.$emit("input", dayjs(this.value).startOf("month").subtract(1, "month").toISOString().toDate());
        },
        goNext() {
            this.$emit("input", dayjs(this.value).startOf("month").add(1, "month").toISOString().toDate());
        },
    },
};
</script>

<style>
</style>